import { Component, Inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-password-req-dialog',
  template: `
    <div class="password-tooltip-content custom-tooltip">
      <div class="popover-title">Requisitos de la contraseña:</div>
      <div class="popover-item" [ngClass]="getReqClass(passwordReqs.length)">
        <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.length) }">{{
          getReqMenuIcon(passwordReqs.length)
        }}</mat-icon>
        Mínimo 12 caracteres
      </div>
      <div class="popover-item" [ngClass]="getReqClass(passwordReqs.uppercase)">
        <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.uppercase) }">{{
          getReqMenuIcon(passwordReqs.uppercase)
        }}</mat-icon>
        Una mayúscula
      </div>
      <div class="popover-item" [ngClass]="getReqClass(passwordReqs.lowercase)">
        <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.lowercase) }">{{
          getReqMenuIcon(passwordReqs.lowercase)
        }}</mat-icon>
        Una minúscula
      </div>
      <div class="popover-item" [ngClass]="getReqClass(passwordReqs.number)">
        <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.number) }">{{
          getReqMenuIcon(passwordReqs.number)
        }}</mat-icon>
        Un número
      </div>
      <div class="popover-item" [ngClass]="getReqClass(passwordReqs.symbol)">
        <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.symbol) }">{{
          getReqMenuIcon(passwordReqs.symbol)
        }}</mat-icon>
        Un símbolo
      </div>
    </div>
  `,
  styles: [
    `
      .password-tooltip-content {
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 12px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
        padding: 1.2rem 1.2rem 1rem 1.2rem;
        min-width: 260px;
        min-height: 180px;
        font-family: 'Open Sans', sans-serif;
      }
      .popover-title {
        font-weight: 550;
        font-size: 18px;
        color: #333333;
        margin-bottom: 12px;
      }
      .popover-item {
        display: flex;
        align-items: center;
        font-size: 15px;
        margin-bottom: 8px;
      }
      .popover-item mat-icon {
        margin-right: 8px;
        font-size: 22px;
      }
      .req-gray mat-icon {
        color: #888 !important;
      }
      .req-green mat-icon {
        color: #43a047 !important;
      }
      .req-red mat-icon {
        color: #e53935 !important;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordReqDialogComponent implements OnInit {
  passwordReqs: any = {
    length: null,
    uppercase: null,
    lowercase: null,
    number: null,
    symbol: null
  };
  constructor(
    public dialogRef: MatDialogRef<PasswordReqDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef
  ) {}

  updateReqs(reqs: any) {
    this.passwordReqs = reqs;
    this.cdr.markForCheck();
  }

  ngOnInit() {}

  getReqClass(val: boolean | null): string {
    if (val === null) return 'req-gray';
    return val ? 'req-green' : 'req-red';
  }
  getReqMenuIcon(val: boolean | null): string {
    if (val === null) return 'radio_button_unchecked';
    return val ? 'check_circle' : 'cancel';
  }
  getReqColor(val: boolean | null): string {
    if (val === null) return '#888';
    return val ? '#43a047' : '#e53935';
  }
}
